import { compareDesc, parse } from 'date-fns'
import { TransactionResponse } from './services/commerce'
interface LiquidateForm {
    [key: string]: string
}

export const formIds: LiquidateForm = {
    name: 'name',
    category: 'category',
    description: 'description',
    shortDescription: 'shortDescription',
    productBrand: 'productBrand',
    classification: 'classification',
    productImage: 'productImage',
    unit: 'unit',
    quantity: 'quantity',
    price: 'price',
    liquidatePrice: 'liquidatePrice',
    stock: 'stock',
}

export const createProductFormIds = {
    productName: 'productName',
    fullDescription: 'fullDescription',
    shortDescription: 'shortDescription',
    productBrandID: 'productBrandID',
    productCategoryID: 'productCategoryID',
    productImage: 'productImage',
    productMeasureUnit: 'productMeasureUnit',
    weight: 'weight',
    price: 'price',
    stock: 'stock',
    isFood: 'isFood',
    ean: 'ean',
    sku: 'sku',
    costPrice: 'costPrice',
    inStoreSales: 'inStoreSales',
    salesInApp: 'salesInApp',
    public: 'public',
}

export function getFormatDate(date: Date) {
    return date.toISOString().split('T')[0]
}

export const formToData = (data: FormData): ILiquidateForm => {
    return Object.keys(formIds).reduce(
        (acc, key) => {
            return { ...acc, [key]: data.get(key) }
        },
        {
            name: '',
            description: '',
            shortDescription: '',
            productBrand: '',
            classification: '',
            productImage: new File([], ''),
            unit: '',
            quantity: '',
            price: '',
            liquidatePrice: '',
            stock: '',
            date: new Date(),
        }
    )
}
export const createProductFormToData = (data: FormData): ICreateProductForm => {
    return Object.keys(createProductFormIds).reduce(
        (acc, key) => {
            return { ...acc, [key]: data.get(key) }
        },
        {
            productName: '',
            fullDescription: '',
            shortDescription: '',
            productBrandID: '0',
            productCategoryID: '0',
            productImage: new File([], ''),
            productMeasureUnit: '',
            weight: '',
            price: '',
            stock: '',
            isFood: false,
            ean: '',
            sku: '',
            costPrice: '',
            inStoreSales: false,
            salesInApp: false,
        }
    )
}
export const getBase64 = (
    file: File,
    callBack: (data: string | ArrayBuffer | null) => void
) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function () {
        callBack(reader.result)
    }
}

export const brandsToOption = (brands: IBrand[]): Option[] => {
    return brands.map<Option>(({ id, name }) => ({
        id: `${id}`,
        label: name,
    }))
}
export const ToOption = (brands: IBrand[]): Option[] => {
    return brands.map<Option>(({ id, name }) => ({
        id: `${id}`,
        label: name,
    }))
}

export const eansToOption = (eans: IEan[]): Option[] => {
    return eans.map((item) => {
        const { id, ean, productName } = item
        return {
            id: `${id}`,
            label: `${ean} (${productName})`,
            productName: `${productName}`,
            fullObject: item,
        }
    })
}

export const categoriesToOption = (brands: ICategory[]): Option[] => {
    return brands.map<Option>(({ id, name, ...rest }) => ({
        ...rest,
        id: `${id}`,
        label: name,
    }))
}
export const formatOptionLabel = (label: string) => {
    return label
        .toLowerCase()
        .replace('á', 'a')
        .replace('é', 'e')
        .replace('í', 'i')
        .replace('ó', 'o')
        .replace('ú', 'u')
        .replace('ü', 'u')
}

export const decimalFormat = (value: string) => {
    let number = value
    let decimals = ''
    const isDecimal = value.includes(',')
    if (isDecimal) {
        number = value.substring(0, value.indexOf(','))
        decimals = value.substring(value.indexOf(',') + 1, value.length)
    }

    number = number?.match(/\d/g)?.join('') || ''

    decimals = decimals?.match(/\d/g)?.join('') || ''
    const style = {
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
        useGrouping: true,
    }

    const preFormatNumber = isDecimal
        ? +`${number}${decimals ? `.${decimals}` : ''}`
        : +number
    const formatter = new Intl.NumberFormat(['es'], style)
    const formatNumber = formatter.format(preFormatNumber)
    return `${formatNumber}`
}

export const numberFormat = (value: string) => {
    if (!value) return ''
    let number = value
    console.log('VALUUEEE', value, value.includes)
    if (value.includes(',')) {
        number = value.substring(0, value.indexOf(','))
    }
    const formatValue = number?.match(/\d/g)?.join('') || 0
    return `${Number(formatValue) || 0}`
}

export const imageToBase64 = (
    file: File | null,
    handler: (base64: string) => void
) => {
    if (file) {
        getBase64(file, (result) => {
            handler((result as string).replace(/^data:image.+;base64,/, ''))
        })
    }
}

export const currencyFormat = (num: number) => {
    return Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
    }).format(num)
}

export const REJECTED = 'RECHAZADA'
export const ANULADA = 'ANULADA'

export const TYPE_TRANSACTION_BCI = 'BCI'

export const addSales = (acc: number, el: TransactionResponse): number => {
    if (el.sEstadoTx === REJECTED) {
        return acc - Number(el.nMonto)
    }

    if (
        el.sEstadoTx === ANULADA &&
        (el.typeTransaction === TYPE_TRANSACTION_BCI ||
            el.sTipoTransaccion === TYPE_TRANSACTION_BCI)
    ) {
        return acc
    }

    return acc + Number(el.nMonto)
}

export const getIncrease = (prev: number, actual: number) => {
    if (prev === 0) {
        return actual === 0 ? 0 : actual > 0 ? 100 : -100
    } else {
        return Math.round(((actual - prev) / prev) * 100)
    }
}

export const parseStringDate = (stringDate: string) => {
    return parse(
        stringDate,
        stringDate.includes('.')
            ? "yyyy-MM-dd'T'HH:mm:ss.SSS"
            : "yyyy-MM-dd'T'HH:mm:ss",
        new Date()
    )
}

export function formatToISO(dateString: string): string {
    const [datePart, timePart] = dateString.split(' ')
    const [year, month, day] = datePart.split('-')
    const [hours, minutes, seconds] = timePart.split(':')

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000`
}

export const sortSales = (sales: TransactionResponse[]) => {
    return sales.sort((a, b) => {
        const dateA = parseStringDate(a.dTransaccion)
        const dateB = parseStringDate(b.dTransaccion)
        return compareDesc(dateA, dateB)
    })
}

export function getCurrentDateTime() {
    const fechaActual = new Date()

    // Obtenemos día, mes y año
    const dia = fechaActual.getDate()
    const mes = fechaActual.getMonth() + 1 // Meses van de 0 a 11, por eso sumamos 1
    const anio = fechaActual.getFullYear()
    // Obtenemos hora y minutos
    const horas = fechaActual.getHours()
    const minutos = fechaActual.getMinutes()

    // Construimos la cadena en el formato deseado
    const fechaFormateada = `${dia}/${mes}/${anio} ${horas}:${
        String(minutos).length === 1 ? '0' + minutos : minutos
    }`

    return fechaFormateada
}

export function formatRut(rut: number | string): string {
    const rutStr = String(rut).replace(/\D/g, '')

    if (rutStr.length === 0) {
        return String(rut)
    }

    const length = rutStr.length
    const part1 = rutStr.slice(0, length - 1)
    const last = rutStr.charAt(length - 1).toUpperCase()

    const all = part1.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

    return `${all}-${last}`
}
